module.exports = __webpack_public_path__ + "static/media/盯盘提醒@2x.c0ec7f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/盯盘提醒@2x.png
// module id = 1580
// module chunks = 0